// extracted by mini-css-extract-plugin
export default {"title":"links_title__oKHoh","list":"links_list__QpIaB"};